import { features } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            平台优势
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            为什么选择我们
          </h2>
          <p className="mt-2 text-sm text-foreground-600">五大核心优势，打造极致观影体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((feature) => (
            <div key={feature.id} className="bg-background-100 rounded-xl p-5 md:p-6 text-center group hover:bg-background-200/70 transition-colors cursor-default">
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-2">{feature.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}